export const scrollToModalTop = () => {
  document.querySelector('.MuiDialog-container').scroll(0, 0);
};
